import { render, staticRenderFns } from "./BL2FL01Component.vue?vue&type=template&id=c2d2ea66&scoped=true&"
import script from "./BL2FL01Component.vue?vue&type=script&lang=js&"
export * from "./BL2FL01Component.vue?vue&type=script&lang=js&"
import style0 from "./BL2FL01Component.vue?vue&type=style&index=0&id=c2d2ea66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d2ea66",
  null
  
)

export default component.exports